import script from "./RoleTargetingFields.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleTargetingFields.vue?vue&type=script&setup=true&lang=js"

import "./RoleTargetingFields.vue?vue&type=style&index=0&id=0f40e9c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f40e9c0"]])

export default __exports__